import {
  GET_SMP_LIST_LOADING,
  GET_SMP_LIST_ERROR,
  GET_SMP_LIST_SUCCESS,
} from "../../../constant/actionTypes";

const initialState = { loading: false, status: {} };

const getSmpListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SMP_LIST_LOADING: {
      let obj = { loading: true };
      return obj;
    }
    case GET_SMP_LIST_SUCCESS: {
      let obj = { loading: false, status: action.response };
      return obj;
    }
    case GET_SMP_LIST_ERROR: {
      let obj = { loading: false, status: action.response };
      return obj;
    }

    default:
      return state;
  }
};

export default getSmpListReducer;
